/**
 * WriteoffSlice Extra Reducers
 * 
 * Handles async actions from RTK Query endpoints.
 */

import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { WriteoffSliceState } from './state';
import { writeoffEndpoints } from '../endpoints/writeoffEndpoints';

/**
 * Builds extra reducers for writeoff API endpoint matchers.
 */
export function buildWriteoffExtraReducers(builder: ActionReducerMapBuilder<WriteoffSliceState>) {
  builder.addMatcher(
    writeoffEndpoints.endpoints.getWriteoff.matchFulfilled,
    (state, action) => {
      state.currentWriteoff = action.payload;
      state.isEdited = false;
      state.editedFields = [];
      state.validationErrors = {};
    }
  );
}
